"use client";
import React, { useEffect } from "react";
import StartTrialBtn from "../StartTrialBtnProducts";
import WhatWeBanner1 from "@/component/Healthcare/WhatweBanner";
import IndustryComponent from "@/component/Healthcare/IndustryComponent";
import Image from "next/image";
import discoveryGoalSettingIco from "@/Helper/images/discovery_goal_setting.svg";
import DataIntegrationPreparationIco from "@/Helper/images/data_integration_preparation.svg";
import InsightGenerationPredictiveModeling from "@/Helper/images/insight_generation_predictive_modeling.svg";
import ActionableImplementationTrainingIco from "@/Helper/images/actionable_implementation_training.svg";
import ContinuousSupportImprovementIco from "@/Helper/images/continuous_support_improvement.svg";


const Healthcare = () => {


  return (
    <>
      <section className="banner_bg1 healthcare_indus_bg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                Transforming healthcare with advanced data analytics
              </h1>
              <p className="banner_text1">
                We empower healthcare providers, payers, and administrators to harness data analytics for a more efficient, transparent, and patient-centred claims process.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about_topsect">
        <div className="container">
          <div className="about_topsectinner">
            <div className="common_titbox">
              <h2 className="common_hd">What we offer</h2>
              <p className="common_desc">
                Our specialized solutions address the complexities of healthcare claims, focusing on cost reduction, fraud detection,
                process efficiency, and better outcomes. Here’s how we help you succeed
              </p>
            </div>
          </div>
        </div>
      </section>
      <WhatWeBanner1 />

      <section className="comm_indusreiessection Casestudies_indusreies">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Case studies</h2>
            <p className="common_desc">
              Our work in the healthcare claims sector is rooted in delivering tangible results.<br /> Here are some
              examples of our success in improving claims processes for clients
            </p>
          </div>
          <div className="indus_inner">
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Reducing Claim Denials by 20% for a Multispecialty Provider
              </h2>
              <p className="indus_desc1">
                We helped a healthcare provider decrease claim denial rates by analyzing and addressing denial patterns, resulting in a 20% improvement in claims acceptance and a substantial reduction in administrative costs.
              </p>
            </div>
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Enhancing Revenue Cycle Efficiency for a Hospital Network
              </h2>
              <p className="indus_desc1">
                Our revenue cycle management analytics helped a hospital network reduce accounts receivable days by 15% and improve cash flow, significantly improving their financial health.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="comm_indusreiessection">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Why choose iKnot?</h2>
          </div>
          <div className="indus_chooseinner">
            <div className="indus_chooselist indus_chooselist1">
              <h3 className="indus_hd1">Healthcare industry expertise</h3>
              <p className="indus_desc1">
                With in-depth experience in healthcare claims analytics, we understand the challenges and complexities of the sector and offer solutions that are designed to meet its unique requirements.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist2">
              <h3 className="indus_hd1">Proven track record</h3>
              <p className="indus_desc1">
                Our analytics solutions deliver measurable improvements, from cost savings and faster claims processing to enhanced compliance and fraud detection.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist3">
              <h3 className="indus_hd1">End-to-End service</h3>
              <p className="indus_desc1">
                We support every stage of the analytics journey, from data integration to insight generation and implementation, providing a comprehensive solution for claims analytics.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist4">
              <h3 className="indus_hd1">Compliance & data security</h3>
              <p className="indus_desc1">
                In healthcare, data security and regulatory compliance are paramount. Our analytics solutions are designed with HIPAA compliance and industry standards in mind to protect patient information and meet regulatory requirements.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist5">
              <h3 className="indus_hd1">Scalable, custom solutions</h3>
              <p className="indus_desc1">
                We recognize that each healthcare organization has unique needs. Our scalable solutions adapt to your evolving requirements, delivering long-term value as your operations grow.
              </p>
            </div>
          </div>
        </div>
      </section> */}
     
      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox">
                <h2 className="common_hd">Our Approach</h2>
                <p className="common_desc">Our analytics-driven approach to healthcare focuses on improving patient outcomes while
                  streamlining operations and enabling smarter, data-driven decisions.</p>
              </div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={discoveryGoalSettingIco}
                    alt="Strategic Operational Insights"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Strategic Operational Insights</h3>
                  <p className="bx_rightdesc">We begin by analyzing your healthcare organization’s management
                    challenges and operational goals. This ensures our solutions are aligned with your objectives to
                    enhance efficiency and decision-making.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={DataIntegrationPreparationIco}
                    alt="Unified Data Ecosystem for Management"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Unified Data Ecosystem for Management</h3>
                  <p className="bx_rightdesc">Healthcare management data spans HR systems, financial
                    records, inventory management, and compliance tracking. We integrate these sources into a
                    centralized platform to provide a clear and cohesive view of operational metrics.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InsightGenerationPredictiveModeling}
                    alt="Workforce and Resource Optimization"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Workforce and Resource Optimization</h3>
                  <p className="bx_rightdesc">Through predictive analytics, we optimize staff scheduling,
                    resource allocation, and supply chain operations, reducing waste and ensuring the right resources
                    are in the right place at the right time.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ActionableImplementationTrainingIco}
                    alt="Financial and Administrative Analytics"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Financial and Administrative Analytics</h3>
                  <p className="bx_rightdesc">Our solutions provide tools to analyze billing processes, track
                    revenue cycles, and manage budgets effectively. This enables healthcare administrators to identify
                    cost-saving opportunities and improve financial performance.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ContinuousSupportImprovementIco}
                    alt="Real-Time Decision Support"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Real-Time Decision Support</h3>
                  <p className="bx_rightdesc">We deliver actionable insights via user-friendly dashboards, enabling
                    administrators to make data-driven decisions on-the-fly. From compliance monitoring to facility
                    management, our tools streamline daily operations.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ContinuousSupportImprovementIco}
                    alt="Continuous Improvement and Compliance"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Continuous Improvement and Compliance</h3>
                  <p className="bx_rightdesc">Healthcare regulations and operational needs evolve
                    continuously. Our analytics frameworks adapt to these changes, ensuring ongoing compliance,
                    operational excellence, and strategic growth.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer healthcaremanufacturecta_bg">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">
                  Ready to leverage data analytics for optimized healthcare? </h3>
                <p className="cta_desc">
                  Get in touch with our experts to discuss  how our solutions can help you achieve better efficiency, cost control, and patient outcomes in your claims process.</p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Healthcare;
